import { Component, OnInit } from '@angular/core';
import {
  AuthService,
  DataService,
} from '../../../shared/services';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadCrumbService } from '../../../shared/services/breadcrumb.service';
import { ChartConfiguration, ChartData } from 'chart.js';

@Component({
  selector: 'app-workload-chart',
  templateUrl: './workload-chart.component.html',
})
export class WorkloadChartComponent implements OnInit {
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      title: {
        display: true,
        text: this.translate.instant(
          'headers.routing.plan.weekly_workload_in_hours'
        ),
        position: 'left',
      },
    },
  };

  public barChartType = 'bar' as const;

  public barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [],
  };

  isLoading = false;

  constructor(
    private translate: TranslateService,
    private data: DataService,
    public auth: AuthService,
    public router: Router,
    public breadCrumbService: BreadCrumbService
  ) {}
  ngOnInit(): void {
    this.loadChartData();
  }

  async loadChartData(): Promise<void> {
    this.isLoading = true;
    const items = await this.data
      .get('api/schedules/normalized_workload')
      .toPromise();
    const transformedData = this.transformData(items);
    this.barChartData = transformedData;
    this.isLoading = false;
  }

  transformData(input: any) {
    const labelsSet = new Set();
    const stateMap = new Map();

    input.forEach((item: any) => {
      const workcenter = (item.workcenter ?? '').trim() || this.translate.instant('navigations.not_applicable');
      const state = item.state.trim();
      const value = item.actualDuration ? parseFloat(item.actualDuration) : 0;

      labelsSet.add(workcenter);

      if (!stateMap.has(state)) {
        stateMap.set(state, new Map());
      }

      const workcenterMap = stateMap.get(state);
      workcenterMap.set(workcenter, (workcenterMap.get(workcenter) || 0) + value);
    });

    const labels = Array.from(labelsSet);

    const datasets = Array.from(stateMap.entries()).map(
      ([state, workcenterMap]) => {
        const data = labels.map((workcenter) => workcenterMap.get(workcenter) || 0);
        return { label: state, data };
      }
    );

    return { labels, datasets };
  }
}
